export var classicUtilities = {
    randomString: function (len) {
        var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz",
            string_length = len,
            randomstring = '';

        for (var i = 0; i < string_length; i++) {
            var rnum = Math.floor(Math.random() * chars.length);
            randomstring += chars.substring(rnum, rnum + 1);
        }

        return randomstring;
    },

    trim: function (str) {
        var str = str.replace(/^\s+/, '');

        for (var i = str.length - 1; i >= 0; i--) {
            if (/\S/.test(str.charAt(i))) {
                str = str.substring(0, i + 1);
                break;
            }
        }

        return str;
    },

    guid: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    cookies: {
        checkIfCookiesEnabled: function () {
            var cookieEnabled = (navigator.cookieEnabled) ? true : false;

            if (typeof navigator.cookieEnabled === "undefined" && !cookieEnabled) {
                document.cookie = "testcookie";
                cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
            }

            return (cookieEnabled);
        },

        eraseCookie: function (c_name) {
            classicUtilities.cookies.setCookie(c_name, "", -1);
        },

        getCookie: function (c_name) {

            var i, x, y, ARRcookies = document.cookie.split(";"),
                result = null;

            for (i = 0; i < ARRcookies.length; i++) {
                x = classicUtilities.trim(ARRcookies[i].substr(0, ARRcookies[i].indexOf("=")));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
                x = x.replace(/^\s+|\s+$/g, "");

                if (x == c_name) {
                    result = unescape(y);
                }
            }

            return result;
        },

        setCookie: function (c_name, value, days) {
            var name = c_name,
                value = value,
                domain = window.location.host,
                path = "/";

            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else {
                var expires = '';
            }

            if (!!!value) {
                value = classicUtilities.randomString(64);
            }

            document.cookie = name + "=" + value + expires + "; path=" + path;
        }
    },
    browserInfo: function () {
        var ua = navigator.userAgent,
            tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return {
                name: 'IE',
                version: (tem[1] || '')
            };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR|Edge\/(\d+)/)
            if (tem != null) {
                return {
                    name: 'Opera',
                    version: tem[1]
                };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    },

    // Added Method 1: URL parameter parsing using URLSearchParams
    getQueryParam: function (url, param) {
        // Create a URL object
        const urlObj = new URL(url);

        // Get the search params from the URL
        const searchParams = urlObj.searchParams;

        // Get the value of the specified parameter
        return searchParams.get(param);
    },
}